//#region Util Imports

import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'

//#endregion

//#region IMR Imports

import { IMRToolbarOptions } from '@imr/controls.angularjs/components/toolbar';

//#endregion

import { OpActivity } from '../../../../../../../../models/core'
import { Enums, Activity } from '../../../../../../../../models/common'

import { OperatorSecurityService } from '../../../../../../../../services/operator'
import { UserSessionService } from '../../../../../../../../services/user-session'

import { LocalizationHelper } from '../../../../../../../../helpers'

import { IMRBaseControlController } from '../../../../../../../common/base'
import { GridOptions, GridController, GridTypes } from '../../../../../../../common/grid'

import { IOperatorDetailsSecurityEffective, OperatorDetailsSecurityEffectiveOptions } from './operator-details.security.effective.interfaces'

export class OperatorDetailsSecurityEffectiveController
    extends
    IMRBaseControlController<IOperatorDetailsSecurityEffective, OperatorDetailsSecurityEffectiveOptions>
    implements
    IOperatorDetailsSecurityEffective {

    //#region Consts

    private get OPERATOR_EFFECTIVE_ACTIVITIES_GRID_NAME() { return 'validActivities' }

    //#endregion


    //#region Members

    public isLoading: boolean

    private currentModuleId: number

    //#endregion


    //#region Ctor

    public constructor(
        private operatorSecurityService: OperatorSecurityService,
        private userSessionService: UserSessionService
    ) {
        super()
    }

    //#endregion


    //#region Component

    protected initialize(options: OperatorDetailsSecurityEffectiveOptions): JQueryPromise<void> {
        this.isLoading = true
        this.currentModuleId = this.operatorSecurityService.getCurrentModuleId()

        return this.operatorSecurityService
            .loadActivityNavProperties(this.options.operator)
            .then(() => {
                return $.when(
                    this.initializeText(),
                    this.initializeGrid(),
                    this.initializeTopToolbar()
                )
            })
            .then(() => {
                this.isLoading = false
            })
    }

    //#endregion


    //#region Grid

    public effectivePermissionsGridOptions: GridOptions
    private effectivePermissionsGrid: GridController<OpActivity>

    private initializeGrid(): void {
        this.effectivePermissionsGridOptions = {
            addCustomFilters: true,
            columnsDictionary: this.operatorSecurityService.getActivityColumns(),
            ignoreKey: true,
            idReferenceType: Enums.ReferenceType.IdActivity,
            name: this.OPERATOR_EFFECTIVE_ACTIVITIES_GRID_NAME,
            type: GridTypes.PAGINATED_SMALL,

            allowColumnReordering: !this.userSessionService
                .getLoggedOperator()
                .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.OperatorSecurityEffectivePermission),

            buttonsOptions: {
                enabled: true,
                isRefreshButonHidden: true
            },

            dataSourceParser: (activity: OpActivity) => {
                return {
                    additionalFields: [{
                        key: 'referenceValue',
                        value: this.operatorSecurityService.getActivityReferenceTypeString(this.options.activityReferenceDict, activity)
                    }]
                }
            },

            getDataSource: () => {
                return this.operatorSecurityService.filterActivityByModule(this.options.operator.allActivities, this.currentModuleId)
            },

            onInitialized: (e: any, grid: GridController<OpActivity>) => {
                this.effectivePermissionsGrid = grid
            },

            onDisposed: () => {
                this.effectivePermissionsGrid = null
            }
        }
    }

    //#endregion


    //#region Text

    public effectivePermissionsInfoText: string

    private initializeText(): void {
        this.effectivePermissionsInfoText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.PermissionInfoText);
    }

    //#endregion


    //#region Toolbar

    public effectivePermissionsTopToolbarOptions: IMRToolbarOptions

    private initializeTopToolbar(): JQueryPromise<any> {
        const moduleSelectBoxOptions: DevExpress.ui.dxSelectBoxOptions = this.operatorSecurityService.getModuleSelectBoxOptions(this.options.modules)

        moduleSelectBoxOptions.disabled = _.size(this.options.modules) === 0
        moduleSelectBoxOptions.searchEnabled = true
        moduleSelectBoxOptions.value = this.currentModuleId
        moduleSelectBoxOptions.width = 300
        moduleSelectBoxOptions.onValueChanged = (e: any) => {
            this.onModuleChanged(e.value)
        }

        if (_.isArray(this.options.modules)) {
            this.effectivePermissionsTopToolbarOptions = {
                items: [{
                    location: 'after',
                    text: `${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ChooseModule)}:`
                },
                {
                    widget: 'dxSelectBox',
                    location: 'after',
                    options: moduleSelectBoxOptions
                }]
            }
        }

        return super.waitForOnInitialized(this.effectivePermissionsTopToolbarOptions)
    }

    private onModuleChanged(moduleId: number) {
        this.currentModuleId = moduleId;

        this.operatorSecurityService.saveCurrentModuleId(moduleId)
        this.effectivePermissionsGrid.dxGrid.refresh()
    }

    //#endregion
}
